"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var AlertStyles_1 = require("@tableau/widgets/lib/src/widgets/AlertStyles");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var TagHelpers_1 = require("../Tag/TagHelpers");
var RootReducer_1 = require("../app/RootReducer");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var ModelResultThunk_1 = require("../store/thunk/ModelResultThunk");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var LayoutStyles_1 = require("../styles/LayoutStyles");
var ModelResultStyles_1 = require("../styles/ModelResultStyles");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var PrometheusEditorHeader_1 = require("./PrometheusEditorHeader");
var Index_1 = require("./base/Index");
var ModelResultAdditionalMetrics_1 = require("./model-results/ModelResultAdditionalMetrics");
var ModelResultExamineModel_1 = require("./model-results/ModelResultExamineModel");
var ModelResultImprovePerformance_1 = require("./model-results/ModelResultImprovePerformance");
var ModelResultOverviewSection_1 = require("./model-results/ModelResultOverviewSection");
var ModelResultReviewPerformance_1 = require("./model-results/ModelResultReviewPerformance");
var ModelResultSummary_1 = require("./model-results/common/ModelResultSummary");
var ModelResultSubspace = function (props) {
    var thunkDispatch = (0, RootReducer_1.useAppThunkDispatch)();
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), status = _a.status, jobId = _a.jobId;
    var trainingJob = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectJob);
    // Need a local variable to track whether component is mounted or not
    // React takes some time to mount a large component to DOM and we want a loading behavior
    // to make UI transition a bit smooth
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var isTrainingJobSame = function () {
        return jobId && trainingJob && jobId === trainingJob.id;
    };
    var isTrainingResultAvailable = function () {
        return isTrainingJobSame() && status === Utils_1.REDUX_STATUS.succeeded;
    };
    React.useEffect(function () {
        setLoading(true);
        if (isTrainingResultAvailable()) {
            setLoading(false);
        }
        else {
            void callAuthOrLoadData();
        }
    }, []);
    var loadData = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(force || !isTrainingJobSame() || status === Utils_1.REDUX_STATUS.idle)) return [3 /*break*/, 4];
                        if (!(trainingJob && !trainingJob.einsteinModelId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)())];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, thunkDispatch((0, ModelResultThunk_1.fetchModelTrainingResult)({
                            storyId: trainingJob.einsteinStoryId,
                            runId: trainingJob.einsteinRunId,
                            jobId: trainingJob.id,
                        }))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleOnCredentialsAddedBeforeLoadData = function () {
        void loadData();
    };
    var callAuthOrLoadData = function () {
        (0, TagHelpers_1.GetSalesForceAuthenticationStatus)({}).then(function (response) {
            if (!response.isAuthenticated) {
                (0, PrometheusEditorHeader_1.doOAuthSignIn)(props.server, handleOnCredentialsAddedBeforeLoadData);
            }
            else {
                void loadData();
            }
        }, function (reason) {
            (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.salesforceAuthenticationError());
            console.log(reason);
        });
    };
    if (loading) {
        return (React.createElement(Index_1.Loader, null,
            React.createElement("div", { className: ModelResultStyles_1.modelResultsChangeSalesforceCredsInfoTextStyle }, Localize_1.Messages.ModelResultsChangeCredentialExplanation()),
            React.createElement("div", null,
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: function () { return (0, PrometheusEditorHeader_1.signoutAndLaunchSalesforceLoginDialog)(props.server, handleOnCredentialsAddedBeforeLoadData); }, testId: TestIds_1.CHANGE_CREDENTIAL_BUTTON_TEST_ID, className: LayoutStyles_1.changeSalesforceCredsButtonStyle, hidden: false }, Localize_1.Messages.changeCredentialButton()))));
    }
    var getErrorWidget = function (message, alertType, retry) {
        if (retry === void 0) { retry = true; }
        var retryProp = retry
            ? {
                label: Localize_1.Messages.retryMessage(),
                onClick: function () {
                    void loadData(true);
                },
            }
            : undefined;
        return (React.createElement(Index_1.Error, { message: message, testId: TestIds_1.MODEL_RESULT_ERROR_CONTAINER_TEST_ID, style: { width: '100%', justifyContent: 'center' }, retry: retryProp, type: alertType }));
    };
    if (!trainingJob || !trainingJob.einsteinStoryId || !trainingJob.einsteinRunId) {
        return getErrorWidget(Localize_1.Messages.modelResultsErrorMessage(), AlertStyles_1.AlertType.Error);
    }
    if (!trainingJob.einsteinModelId) {
        return getErrorWidget(Localize_1.Messages.modelResultsNoModelErrorMessage(), AlertStyles_1.AlertType.Warning, false);
    }
    if (status === Utils_1.REDUX_STATUS.failed) {
        return getErrorWidget(Localize_1.Messages.modelResultsErrorMessage(), AlertStyles_1.AlertType.Error);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModelResultSummary_1.default, null),
        React.createElement(ModelResultOverviewSection_1.default, null),
        React.createElement(ModelResultImprovePerformance_1.default, null),
        React.createElement(ModelResultReviewPerformance_1.default, null),
        React.createElement(ModelResultAdditionalMetrics_1.default, null),
        React.createElement(ModelResultExamineModel_1.default, null)));
};
exports.default = ModelResultSubspace;
//# sourceMappingURL=ModelResultSubspace.js.map